/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PartnerDecision = {
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered'
} as const;
export type PartnerDecision = typeof PartnerDecision[keyof typeof PartnerDecision];


export function PartnerDecisionFromJSON(json: any): PartnerDecision {
    return PartnerDecisionFromJSONTyped(json, false);
}

export function PartnerDecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerDecision {
    return json as PartnerDecision;
}

export function PartnerDecisionToJSON(value?: PartnerDecision | null): any {
    return value as any;
}

